import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { connect } from 'react-redux'

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
  icon: {
    margin: theme.spacing.unit * 2,
  },
});

function Loading(props) {
  const { classes, type} = props;
  return (
    <div>
      
      {/* {
          props.showSuccess && 
          <CircularProgress className={classes.progress} size={100}>
            <HomeIcon className={classes.icon} />
          </CircularProgress>
      } */}
      { 
          type === "linear" ? <LinearProgress /> : <CircularProgress className={classes.progress} size={100}></CircularProgress>
      }
    </div>
  );
}

// Loading.propTypes = {
//   classes: PropTypes.object.isRequired,
// };
const mapStateToProps = function(state,ownProps) {
    return {
      type : ownProps.type || "linear",
    }
  }
const LoadingConnect = connect(mapStateToProps)(withStyles(styles)(Loading))

export default LoadingConnect;